function i(e, t, l) {
  for (var n = -1, u = e == null ? 0 : e.length; ++n < u; )
    if (l(t, e[n]))
      return !0;
  return !1;
}
export {
  i as default
};
